module.exports = __webpack_public_path__ + "static/img/3b.3c745a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/3b.jpg
// module id = jseL
// module chunks = 1